import { Check } from "@material-ui/icons";
import React from "react";

function Steps({ state, setState }) {
  const getStepNumber = (number) => {
    if (number > state - 1) return number;
    return <Check />;
  };
  return (
    <div className="d-flex flex-lg-column flex-row align-items-start justify-content-center pl-3 steps-container sticky-top pb-3">
      <div
        className={`d-flex align-items-center justify-content-center ${
          state >= 1 ? "visited" : "not-visited"
        }`}
      >
        <div className="circle-step-wrapper">{getStepNumber(1)}</div>
        <div className="d-none d-lg-flex">Select Date &amp; Time</div>
      </div>
      <div
        className={`d-flex align-items-center justify-content-center ${
          state >= 2 ? "visited" : "not-visited"
        }`}
      >
        <div className="circle-step-wrapper">{getStepNumber(2)}</div>
        <div className="d-none d-lg-flex">Select Patient</div>
      </div>
      <div
        className={`d-flex align-items-center justify-content-center ${
          state >= 3 ? "visited" : "not-visited"
        }`}
      >
        <div className="circle-step-wrapper">{getStepNumber(3)}</div>
        <div className="d-none d-lg-flex">Review &amp; Share</div>
      </div>
    </div>
  );
}

export default Steps;
